<template>
  <v-app>
    <GlobalNav />

    <v-main class="position-relative">
      <SidebarNavigation v-model:drawer="drawer" />

      <div class="crm-slot">
        <v-row>
          <v-col cols="12" md="6">
            <div class="d-flex gap-4 align-center">
              <v-btn
                class=" d-lg-none crm-opnav mr-4 elevation-0 arrow-btn"
                variant="text"
                icon
                @click.stop="drawer = !drawer"
              >
                <v-icon>mdi-chevron-double-right</v-icon>
              </v-btn>

              <BreadCrumb :linksData="linksData"  />
            </div>
          </v-col>
        </v-row>

        <slot></slot>
      </div>
    </v-main>
  </v-app>
</template>

<script setup>
import { ref, watch } from "vue";
import { useDisplay } from "vuetify";
import SidebarNavigation from "@/components/crm/layouts/sidebar.vue";
import GlobalNav from "@/components/layout/GlobalNav.vue";
import BreadCrumb from "@/components/layout/BreadCrumb.vue";

defineProps({
  linksData: Array,
});

// استخدم Vuetify helper للكشف عن الشاشات الصغيرة
const { smAndDown } = useDisplay();
const drawer = ref(!smAndDown.value);

// غيّر حالة الـ sidebar بناءً على حجم الشاشة
watch(smAndDown, (isSmall) => {
  drawer.value = !isSmall;
});
</script>

<style>
.v-application {
  max-width: 100%;
}
.v-navigation-drawer {
  height: 100% !important;
}
.v-main {
  min-height: 100vh;
}
.arrow-btn {
  background-color: transparent;
  border: 2px dashed #237276;
  transition: 0.5s;
  width: 2rem !important;
  height: 2rem !important;
}
</style>
